export default __webpack_public_path__ + "static/6614-3da1cb50276a4e7d941e69f5cd6a9025.jpg";